import store from '@/store'

function $has (code) {
  if (!code) return true
  let funCodes = []
  if (store.state.app.user) funCodes = store.state.app.user.funCodes ? store.state.app.user.funCodes : []
  for (let i = 0; i < funCodes.length; ++i) {
    if (funCodes[i] === code) return true
  }
  return false
}

/**
 * 按钮级的权限控制
 * @param {*} code 权限编码
 */
export function has (code) {
  return $has(code)
}



// WEBPACK FOOTER //
// ./src/libs/auth.js